import React, { Component } from 'react';

import NewShadeForm from "./NewShadeForm";
import NewAccessoryForm from "./NewAccessoryForm";
import DescriptionSlides from '../../DescriptionSlides';
import { NewFabricForm } from './NewFabricSampleForm';

import PartsForm from '../../PartsForm';

class ProductForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			focusedOption: null,
			tab: 0,
			showRequired: false
		};
	}

	setFocusedOption(opt) {
		this.setState({
			focusedOption: opt
		});
	}

	setTab(index) {
		this.setState({
			tab: index
		});
	}

	setShowRequired(input) {
		this.setState({
			showRequired: input
		});
	}

	render() {
		const {
			showRequired, focusedOption, tab
		} = this.state;
		const { props } = this;

		const contents = [

			<NewShadeForm
				quoteType={props.quoteType}
				newQuote={props.newQuote}
				quote={props.quote}
				setFocusedOption={this.setFocusedOption}
				onOptionBlur={(option) => setTimeout(() => {
					if (option === null || (focusedOption === option.varName)) {
						setFocusedOption(null);
					}
				}, 200)}
				setShowRequired={this.setShowRequired}
				onCancel={props.onCancel}
				onAdd={props.onAdd}
				close={props.close}
			/>,
			<NewAccessoryForm
				quoteType={props.quoteType}
				accessories={props.newQuote.globals.ACCESSORIES}
				onDone={props.close}
				quoteAccessories={props.newQuote.Data.accessories.Items}
				setAccessoryQuantity={props.newQuote.Data.setAccessoryQuantity}
				newQuote={props.newQuote}
			/>,
			<NewFabricForm
				quoteType={props.quoteType}
				invoiceTable={false}
				samples={props.newQuote.globals.FABRICS}
				quoteSamples={props.newQuote.Data.fabricSamples.Items}
				isManuacturer // cSpell:disable-line
				onDone={props.close}
				onChange={props.newQuote.Data.changeFabricSampleQuantity}
			/>,
		];

		const showParts = props.newQuote.QuoteType !== 'CEDIA';

		if (showParts) {
			contents.push(<PartsForm
				quoteType={props.quoteType}
				onDone={props.close}
				newQuote={props.newQuote}
            
			/>);
		}

		return (

			<>

				<div className={`option-description ${focusedOption && DescriptionSlides[focusedOption.varName] ? 'show' : ''}`}>
					{
						focusedOption && DescriptionSlides[focusedOption.varName]
							? DescriptionSlides[focusedOption.varName](focusedOption)
							: null
					}
				</div>

				<div className={`product-form ${showRequired ? 'show-required' : ''} showing-description-modal`}>

					<div className="mode-toggle">

						<div className={tab == 0 ? `active ${props.quoteType}` : ''} onClick={() => this.setTab(0)}>
							Shades
						</div>

						<div className={tab == 1 ? `active ${props.quoteType}` : ''} onClick={() => this.setTab(1)}>
							Accessories
						</div>

						<div className={tab == 2 ? `active ${props.quoteType}` : ''} onClick={() => this.setTab(2)}>
							Samples
						</div>
						{showParts ? (
							<div className={tab == 3 ? `active ${props.quoteType}` : ''} onClick={() => this.setTab(3)}>
								Parts
							</div>
						) : null}

					</div>

					{contents[tab]}

				</div>
			</>
		);
	}
}

export default ProductForm;
